import {TAILWIND_SCREENS} from './tailwind-screens.config';

export const VIEWPORT_MEDIA_QUERIES = {
  mdAndUp: `(min-width: ${TAILWIND_SCREENS.md})`,
  lgAndUp: `(min-width: ${TAILWIND_SCREENS.lg})`,
} as const;
